import { PlusCircleOutlined, RightOutlined } from '@ant-design/icons';
import { Button, notification, Space, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { StatePieceStatus } from '../../../../../enums';
import { IProjectLookupListTableRow } from '../../../../../interfaces/lookup/project';
import { ContentHeader } from '../../../../../shared/components/appSkeleton/contentHeader/ContentHeader';
import { NOTIFICATION_PLACEMENT } from '../../../../../shared/Constants';
import { AppDispatch, RootState } from '../../../../../store';
import { fetchProjects } from '../../../../../store/lookupSlice/LookupActions';
import { resetState } from '../../../../../store/lookupSlice/LookupSlice';

export const ProjectLookupListOverview = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { projects } = useSelector((state: RootState) => state.lookupSlice);

    const columns: ColumnsType<IProjectLookupListTableRow> = [
        {
            title: 'Code',
            dataIndex: 'code',
            key: 'code',
            render: (_, record) => (
                <>
                    <Tooltip title={record.description}>{record.code}</Tooltip>
                </>
            ),
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: '',
            dataIndex: 'actions',
            key: 'actions',
            width: 100,
            render: (_, record) => (
                <Space size="middle">
                    <Button type="text" icon={<RightOutlined />} onClick={() => navigate(`/admin/lookup-lists/project/${record.id}`)} />
                </Space>
            ),
        },
    ];

    useEffect(() => {
        if (projects.model.updateStatus === StatePieceStatus.Success) {
            navigate('/admin/lookup-lists/project', { replace: true });
        }
    }, [projects.model.updateStatus]);

    useEffect(() => {
        dispatch(fetchProjects());

        return () => {
            dispatch(resetState());
        };
    }, []);

    useEffect(() => {
        if (projects.model.fetchStatus === StatePieceStatus.Error) {
            notification.error({
                message: 'An error occurred.',
                duration: 0,
                description: 'An error occurred while retrieving the data. Please contact your administrator if the problem persists.',
                placement: NOTIFICATION_PLACEMENT,
            });
        }
    }, [projects.model.fetchStatus]);

    return (
        <div className="app-page">
            <ContentHeader
                title="Manage projects lookup list"
                breadcrumbs={[
                    {
                        breadcrumbName: 'Admin',
                        path: '/admin',
                    },
                    {
                        breadcrumbName: 'Manage lookup lists',
                        path: '/admin/lookup-lists',
                    },
                    {
                        breadcrumbName: 'Projects',
                        path: '/admin/lookup-lists/project',
                    },
                ]}
            >
                <>
                    <Button type="primary" icon={<PlusCircleOutlined />} onClick={() => navigate('/admin/lookup-lists/project/add')}>
                        Add new project
                    </Button>
                </>
            </ContentHeader>

            <div className="page-content">
                <Table
                    size="small"
                    bordered={true}
                    loading={projects.model.fetchStatus === StatePieceStatus.IsFetching}
                    dataSource={projects.model.data.map((option, i) => {
                        return { ...option, key: i } as IProjectLookupListTableRow;
                    })}
                    columns={columns}
                    pagination={{
                        defaultPageSize: 100,
                    }}
                />
            </div>
        </div>
    );
};
